import { AbilityBuilder } from '@casl/ability';
import * as Mutations from './mutations';
import * as accessList from './access-list.json';

export const AccessListModule = {
    state: {
        ability: null
    },

    mutations: {
        [Mutations.SET_ABILITY](state, ability) {
            state.ability = ability;
        },
    },

    actions: {
        configureAbility: async ({ commit }, role) => {
            const defineRules = (can) => {
                _.forEach(accessList, (value, key) => {
                    value[role] && can([...value[role]], key)
                });
            };
            const ability = AbilityBuilder.define(defineRules);
            commit(Mutations.SET_ABILITY, ability);
        }
    },

    getters: {
        ability: state => state.ability
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/access-list/access-list.module.js